import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import { auth, db } from "./firebase";
import { useNavigate } from "react-router-dom";
import { createAdminUser } from "./utils/createAdmin";
import "./styles/global.css";


const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    usuario: "", // Puede ser cédula o correo
    password: ""
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const isEmail = formData.usuario.includes("@");
      if (isEmail) {
        // Login por correo (admin, superadmin, rrhh, psicologo, etc)
        try {
          await signInWithEmailAndPassword(auth, formData.usuario, formData.password);
          // Buscar datos del usuario en Firestore para saber el rol
          const q = query(
            collection(db, "usuarios"),
            where("email", "==", formData.usuario),
            where("estado", "==", "activo")
          );
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            const userData = querySnapshot.docs[0].data();
            // Redirigir según el rol
            if (userData.rol === "superadmin" || userData.rol === "admin") {
              navigate("/");
            } else if (userData.rol === "rrhh") {
              navigate("/rrhh");
            } else if (userData.rol === "psicologo") {
              navigate("/psicologo");
            } else {
              // Si es otro rol, por defecto dashboard empleado
              localStorage.setItem('empleadoSession', JSON.stringify({
                id: querySnapshot.docs[0].id,
                ...userData,
                loginTime: new Date().toISOString()
              }));
              navigate('/dashboard-empleado');
            }
            return;
          } else {
            // Si no está en la colección usuarios, ir al dashboard admin por defecto
            navigate("/");
            return;
          }
        } catch (authError) {
          // Si el usuario no existe y es el admin predeterminado, crearlo
          if (formData.usuario === "admin@ossinnovation.com" && formData.password === "ADM1Noss!") {
            await createAdminUser();
            await signInWithEmailAndPassword(auth, formData.usuario, formData.password);
            navigate('/');
            return;
          } else {
            throw authError;
          }
        }
      } else {
        // Login por cédula (solo números)
        if (!formData.usuario) {
          setError("Por favor ingresa tu número de cédula");
          return;
        }
        const q = query(
          collection(db, "usuarios"),
          where("cedula", "==", formData.usuario),
          where("estado", "==", "activo")
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          setError("Cédula no encontrada o usuario inactivo");
          return;
        }
        const empleadoData = querySnapshot.docs[0].data();
        localStorage.setItem('empleadoSession', JSON.stringify({
          id: querySnapshot.docs[0].id,
          ...empleadoData,
          loginTime: new Date().toISOString()
        }));
        navigate('/dashboard-empleado');
        return;
      }
    } catch (err) {
      setError("Credenciales incorrectas o usuario no encontrado.");
      console.error("Error en login:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ 
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '450px',
        width: '100%',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ 
            fontSize: '2em', 
            fontWeight: '700', 
            color: '#1e40af',
            marginBottom: '8px'
          }}>
            Elipse 360°
          </h1>
          <p style={{ color: '#64748b' }}>
            Sistema de Evaluación de Desempeño
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ minHeight: '200px' }}>
          <div style={{ paddingBottom: '20px' }}>
            <div className="form-group">
              <label className="form-label">Correo electrónico o Cédula</label>
              <input
                type="text"
                className="form-input"
                value={formData.usuario}
                onChange={(e) => setFormData({ ...formData, usuario: e.target.value })}
                required
                autoFocus
                placeholder="Ingresa tu correo o cédula"
                style={{ fontSize: '18px', textAlign: 'center' }}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Contraseña</label>
              <input
                type="password"
                className="form-input"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required={formData.usuario.includes("@")}
                placeholder={formData.usuario.includes("@") ? "••••••••" : "(Solo para correo)"}
                disabled={!formData.usuario.includes("@")}
                style={{ background: !formData.usuario.includes("@") ? '#f1f5f9' : 'white' }}
              />
              {!formData.usuario.includes("@") && (
                <small style={{ color: '#64748b', fontSize: '0.9em', display: 'block', marginTop: '8px' }}>
                  Solo ingresa tu cédula, sin contraseña
                </small>
              )}
            </div>
          </div>
          
          {error && (
            <div style={{ 
              background: '#fef2f2',
              border: '1px solid #fecaca',
              color: '#dc2626',
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '16px',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}
          
          <button 
            type="submit" 
            className="btn btn-primary"
            disabled={loading}
            style={{ 
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
        
        <div style={{ 
          marginTop: '24px', 
          textAlign: 'center', 
          fontSize: '14px', 
          color: '#64748b' 
        }}>
          <p>¿Necesitas acceso? Contacta al administrador del sistema.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
